import { styled, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { ReactNode } from "react";

const CircleRedContainer = styled(Stack)(({ theme }) => ({
  width: "18px",
  height: "18px",
  border: "1px solid",
  borderColor: theme.palette.text10.main,
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.accentDanger30.main,
  borderRadius: "50%",
  pointerEvents: "none",
})) as typeof Stack;

const CircleWithCount = ({ count }: { bottom?: string; left?: string; count: number }) => {
  return (
    <CircleRedContainer>
      <Typography variant="body.xSmall.regular" sx={{ color: "text10.main" }}>
        {count > 9 ? "+" : count}
      </Typography>
    </CircleRedContainer>
  );
};

const IconForFilter = ({
  iconComponent,
  count,
  show = true,
  bottom = "0px",
  left = "0px",
}: {
  iconComponent: ReactNode;
  count: number;
  show?: boolean;
  bottom?: string;
  left?: string;
}) => {
  return (
    <Stack sx={{ position: "relative" }}>
      {iconComponent}
      {show && (
        <Stack sx={{ bottom, left, position: "absolute" }}>
          {count > 0 ? (
            <Stack
              sx={(theme) => ({
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: theme.palette.accentDanger30.main,
              })}
            />
          ) : null}
        </Stack>
      )}
    </Stack>
  );
};

export { CircleWithCount, IconForFilter };
